import React from 'react';

import Chip from '@components/Chip';
import { formatNumber } from '@helpers/Formatters';
import { Plan } from '@types';

export type PlanCommentButtonProps = {
  planDoc: Pick<Plan, 'numComments'>;
  onPress: () => void;
};

export default function PlanCommentButton({ planDoc, onPress }: PlanCommentButtonProps) {
  const numComments = planDoc.numComments || 0;

  return (
    <Chip onPress={onPress} icon="comment-outline">
      {numComments > 0
        ? `${formatNumber(numComments)} Comment` + (numComments > 1 ? 's' : '')
        : 'Comment'}
    </Chip>
  );
}
